module.exports = __webpack_public_path__ + "media/images/emblems/Daegerlen-blazon-f647b67ae1b003aafe60f1f63aab57f0.svg";